// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3mSvw","log":"ModalInventoryLogs_log__5bhDw","date":"ModalInventoryLogs_date__KSbSl","userName":"ModalInventoryLogs_userName__3DOlf"};